import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { PostmethodService } from "../../app-config/postmethod.service";

@Injectable({
  providedIn: "root",
})
export class UsersService {
  private apiUrl = `${environment.baseUrl}user`;
  private mspinUrl = `${environment.baseUrl}admin/master/masterRecords?type=24`;

  constructor(private http: HttpClient, private ws: PostmethodService) { }

  createUser(userData: any): Observable<any> {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });

    console.log(userData);
    return this.http.post(this.apiUrl, userData, { headers });
  }

  getUserList(): Observable<any> {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.http.get(`${this.apiUrl}/list`, { headers });
  }
  updateUser(id: number, data: any) {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.http.put(`${this.apiUrl}/update-profile/${id}`, data, { headers });
  }

  getMspin(): Observable<any> {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.http.get(`${this.mspinUrl}`, { headers });
  }

  resetPassword(payload: { username: string, password: string; cpassword: string }): Observable<any> {
    const token = sessionStorage.getItem("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.http.post(`${environment.baseUrl}auth/resetPassword`, payload, { headers });
  }

  getUserExport() {
    return this.ws.wsGet(environment.baseUrl + "reports/userGenerateReport");
  }

  getMasters() {
    return this.ws.wsGet(environment.baseUrl + "admin/master/masterRecords");
  }

  getExportData(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "reports/userExportReport");
  }

  userUnBlock(request: any) {
    return this.ws.wsPutById(environment.baseUrl + "user/unblockUser", request.id);
  }

  exportManpower() {
    return this.ws.wsGet(environment.baseUrl + "reports/manpowerUsers");
  }

  getVerifiedUserList(id: any, type: string) {
    return this.ws.wsGet(
      `${environment.baseUrl}user/verificationUsers/${id}?type=${type}`
    );
  }
}
